import { render, staticRenderFns } from "./CustomerSatisfactionComponent.vue?vue&type=template&id=47d6fadc"
import script from "./CustomerSatisfactionComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerSatisfactionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports